var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquare4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.04302 0 0 .027554 0 12.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame",
    transform: "translate(37.364 -5.2366)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 8.4534
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.0000029738,
    y: -448.12,
    width: 135.31,
    height: 211.25,
    rx: 33.827,
    ry: 52.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.21,
    y: -448.12,
    width: 135.31,
    height: 211.25,
    rx: 33.827,
    ry: 52.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.21,
    y: -179.25,
    width: 135.31,
    height: 211.25,
    rx: 33.827,
    ry: 52.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5527e-15,
    y: -179.25,
    width: 135.31,
    height: 211.25,
    rx: 33.827,
    ry: 52.813
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare4);
export default __webpack_public_path__ + "static/media/square4.cc1ce914c2ed7ab938579b7bb99f71ba.svg";
export { ForwardRef as ReactComponent };